import { axiosWithAuth } from "@/lib/AxiosClient";

export class User {
  constructor(id: string, userId: string, name: string, email: string) {
    this.id = id
    this.userId = userId
    this.name = name
    this.email = email
    this.inviteCode = null
  }

  id: string
  userId: string
  name: string
  email: string
  inviteCode: string | null
}

export interface UserAccess {
  id: string;
  userId: string;
  name: string;
  email: string;
  permission: UserPermission;
}

export type UserPermission = SiteUserPermission | TenantUserPermission;

export interface UserPermissionBase {
  read: boolean;
  write: boolean;
  type: "Site" | "Tenant";
}

export interface SiteUserPermission extends UserPermissionBase {
  type: "Site";
  siteId: string;
}

export interface TenantUserPermission extends UserPermissionBase {
  type: "Tenant";
}

export class UserService {
  private static readonly BASE_PATH = "/api/users"
  private static instance = axiosWithAuth;

  static async getById(userId: string): Promise<User> {
    const response = await this.instance.get<User>(`${this.BASE_PATH}/${userId}`);
    return response.data;
  }  

  static async getMe(): Promise<User> {
    const response = await this.instance.get<User>(`${this.BASE_PATH}/me`);
    return response.data;
  } 
  
  static async getBySiteId(siteId: string): Promise<User[]> {
    const response = await this.instance.get<User[]>(`${this.BASE_PATH}/sites/${siteId}`);
    return response.data;
  }

  static async getUserAccessBySiteId(siteId: string): Promise<UserAccess[]> {
    const response = await this.instance.get<UserAccess[]>(`${this.BASE_PATH}/sites/${siteId}/permissions`);
    return response.data;
  }

  static async removeUserPermissionBySiteId(permissionAssignmentId: string, siteId: string): Promise<void> {
    await this.instance.delete<void>(`${this.BASE_PATH}/permissions/${permissionAssignmentId}/sites/${siteId}`);
  }
}